<div>
    <ul>
        <li
            ><a
                href="http://www.wa.gov.au"
                target="_blank"
                >Government of Western Australia website</a
            ></li
        >
        <li class="last"
            ><a
                href="https://www.landgate.wa.gov.au"
                target="_blank"
                >Landgate website</a
            ></li
        >
        <li class="release-version">Release: {{ releaseVersion()}} </li>
    </ul>
</div>
